import { defineStore } from 'pinia'
import { ref } from 'vue'
import axiosInstance from '@/helpers/axios'
import { SwalSuccess, SwalError, SwalDelete } from '@/helpers/mySwal'

export const useJobTemplateStore = defineStore('jobTemplate', () => {
  const jobTemplates = ref([])
  const jobTemplate = ref({})
  const loading = ref(false)
  const isLoaded = ref(false)
  const isLoadedOne = ref(false)

  const getAllJobTemplates = async () => {
    if (loading.value) {
      await new Promise((resolve) => setTimeout(resolve, 1000))
      await getAllJobTemplates()
    } else if (!isLoaded.value) {
      await readAllJobTemplates()
    }
  }

  const readAllJobTemplates = async () => {
    loading.value = true
    try {
      const { data } = await axiosInstance.get('/api/jobTemplates')
      jobTemplates.value = data
      isLoaded.value = true
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'טעינת תבניות משימה נכשלה'
      })
    } finally {
      loading.value = false
    }
  }

  const getOneJobTemplate = async (id) => {
    loading.value = true
    try {
      const { data } = await axiosInstance.get(`/api/jobTemplates/${id}`)
      jobTemplate.value = data
      isLoadedOne.value = true
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'טעינת תבנית משימה נכשלה'
      })
    } finally {
      loading.value = false
    }
  }

  const createJobTemplate = async (data) => {
    loading.value = true
    try {
      const { data: jobTemplate } = await axiosInstance.post('/api/jobTemplates', data)
      if (isLoaded.value) {
        jobTemplates.value.push(jobTemplate)
      }

      SwalSuccess.fire({
        title: 'תבנית משימה חדש נוצר בהצלחה'
      })
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'הוספת תבנית משימה נכשלה'
      })
    } finally {
      loading.value = false
    }
  }

  const updateJobTemplate = async (data) => {
    loading.value = true
    try {
      const { data: updatedJobTemplate } = await axiosInstance.put(
        `/api/jobTemplates/${data.id}`,
        data
      )

      if (isLoaded.value) {
        jobTemplates.value = jobTemplates.value.map((jobTemplate) =>
          jobTemplate.id === data.id ? updatedJobTemplate : jobTemplate
        )
      }

      if (isLoadedOne.value) {
        jobTemplate.value = updatedJobTemplate
      }

      SwalSuccess.fire({
        title: 'פרטי התבנית משימה עודכנו בהצלחה'
      })
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'עדכון תבנית משימה נכשל'
      })
    } finally {
      loading.value = false
    }
  }

  const deleteJobTemplate = async (id) => {
    loading.value = true
    try {
      await axiosInstance.delete(`/api/jobTemplates/${id}`)
      if (isLoaded.value) {
        jobTemplates.value = jobTemplates.value.filter((jobTemplate) => jobTemplate.id !== id)
      }

      SwalSuccess.fire({
        title: 'פרטי התבנית משימה נמחקו בהצלחה'
      })
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'מחיקת תבנית משימה נכשלה'
      })
    } finally {
      loading.value = false
    }
  }

  const confirmDelete = async (id) => {
    const confirm = await SwalDelete.fire({
      text: `האם אתה בטוח שברצונך למחוק את התבנית משימה?`
    })

    if (confirm.isConfirmed) {
      await deleteJobTemplate(id)
    }
  }

  const $reset = () => {
    jobTemplates.value = []
    jobTemplate.value = {}
    loading.value = false
    isLoaded.value = false
    isLoadedOne.value = false
  }

  return {
    jobTemplates,
    jobTemplate,
    loading,
    isLoaded,
    isLoadedOne,
    getAllJobTemplates,
    getOneJobTemplate,
    createJobTemplate,
    updateJobTemplate,
    deleteJobTemplate,
    confirmDelete,
    $reset
  }
})
